var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "card",
      attrs: {
        open: false,
        animation: "slide",
        "aria-id": "contentIdForA11y3",
      },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function (props) {
            return [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: {
                    role: "button",
                    "aria-controls": "contentIdForA11y3",
                  },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _c("i", { staticClass: "fas fa-filter" }),
                    _vm._v(" Filtros"),
                  ]),
                  _vm._v(" "),
                  _c("a", { staticClass: "card-header-icon" }, [
                    _c("i", {
                      staticClass: "fas fa-lg",
                      class: props.open ? "fa-angle-up" : "fa-angle-down",
                    }),
                  ]),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-content" },
        [
          _c(
            "b-field",
            { staticClass: "mb-4" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "fecha-accion" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        Fecha acción\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("fecha-accion")
                ? _c(
                    "b-datepicker",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        "aria-label": "desde",
                        placeholder: "desde - DD/MM/AAAA",
                        icon: "calendar-today",
                        locale: _vm.locale,
                        size: "is-small",
                        "date-formatter": _vm.dateFormatter,
                      },
                      model: {
                        value: _vm.model.fechaDesde,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "fechaDesde", $$v)
                        },
                        expression: "model.fechaDesde",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            label: "Borrar fecha",
                            "icon-left": "times",
                            type: "is-danger",
                            expanded: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.model.fechaDesde = null
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-times" }),
                          _vm._v("  Borrar fecha\n            "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkboxGroup.includes("fecha-accion")
                ? _c(
                    "b-datepicker",
                    {
                      attrs: {
                        placeholder: "hasta - DD/MM/AAAA",
                        icon: "calendar-today",
                        locale: _vm.locale,
                        size: "is-small",
                        "date-formatter": _vm.dateFormatter,
                      },
                      model: {
                        value: _vm.model.fechaHasta,
                        callback: function ($$v) {
                          _vm.$set(_vm.model, "fechaHasta", $$v)
                        },
                        expression: "model.fechaHasta",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            label: "Borrar fecha",
                            "icon-left": "times",
                            type: "is-danger",
                            expanded: "",
                          },
                          on: {
                            click: function ($event) {
                              _vm.model.fechaHasta = null
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fas fa-times" }),
                          _vm._v("  Borrar fecha\n            "),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            { staticClass: "mb-4" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "usuarioId" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        Usuario\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("usuarioId") && !_vm.selectedUser
                ? _c(
                    "b-autocomplete",
                    {
                      attrs: {
                        size: "is-small",
                        data: _vm.searchUserResults,
                        placeholder: "Escriba nombre o apellido",
                        loading: _vm.isFetching,
                      },
                      on: {
                        input: _vm.getUser,
                        select: (option) => _vm.selectUser(option),
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (props) {
                              return [
                                _c("i", { staticClass: "fas fa-user" }),
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      props.option.apellido.toUpperCase()
                                    ) +
                                    ", " +
                                    _vm._s(props.option.nombre) +
                                    "\n          "
                                ),
                                _c("br"),
                                _vm._v(" "),
                                _c("span", { staticClass: "is-size-7" }, [
                                  _vm._v(
                                    _vm._s(props.option.cuil) +
                                      " - " +
                                      _vm._s(props.option.email)
                                  ),
                                ]),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        958257474
                      ),
                      model: {
                        value: _vm.userInput,
                        callback: function ($$v) {
                          _vm.userInput = $$v
                        },
                        expression: "userInput",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("template", { slot: "empty" }, [
                        _vm._v(
                          "No hay resultados para " + _vm._s(_vm.userInput)
                        ),
                      ]),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.checkboxGroup.includes("usuarioId") && _vm.selectedUser
                ? _c("p", [
                    _c(
                      "a",
                      {
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.clearSelectedUser()
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-times-circle" })]
                    ),
                    _vm._v(
                      " " +
                        _vm._s(_vm.selectedUser.apellido.toUpperCase()) +
                        ",\n        " +
                        _vm._s(_vm.selectedUser.nombre) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            { staticClass: "mb-4" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "ipOrigen" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        IP origen\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("ipOrigen")
                ? _c("b-input", {
                    attrs: { placeholder: "IP origen", size: "is-small" },
                    model: {
                      value: _vm.model.ipOrigen,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "ipOrigen", $$v)
                      },
                      expression: "model.ipOrigen",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            { staticClass: "mb-4" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "accion" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        Acción\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("accion")
                ? _c("b-input", {
                    attrs: { placeholder: "acción", size: "is-small" },
                    model: {
                      value: _vm.model.accion,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "accion", $$v)
                      },
                      expression: "model.accion",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            { staticClass: "mb-4" },
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "entidad" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        Entidad\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("entidad")
                ? _c("b-input", {
                    attrs: { placeholder: "entidad", size: "is-small" },
                    model: {
                      value: _vm.model.entidad,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "entidad", $$v)
                      },
                      expression: "model.entidad",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-field",
            [
              _c(
                "b-checkbox",
                {
                  attrs: { "native-value": "entidadId" },
                  model: {
                    value: _vm.checkboxGroup,
                    callback: function ($$v) {
                      _vm.checkboxGroup = $$v
                    },
                    expression: "checkboxGroup",
                  },
                },
                [_vm._v("\n        ID Entidad\n      ")]
              ),
              _vm._v(" "),
              _vm.checkboxGroup.includes("entidadId")
                ? _c("b-input", {
                    attrs: {
                      type: "number",
                      step: "1",
                      min: "1",
                      placeholder: "ID entidad",
                      size: "is-small",
                    },
                    model: {
                      value: _vm.model.entidadId,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "entidadId", $$v)
                      },
                      expression: "model.entidadId",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("footer", { staticClass: "card-footer" }, [
        _c(
          "a",
          { staticClass: "card-footer-item", on: { click: _vm.emitToParent } },
          [_vm._v("Filtrar")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }